import { render, staticRenderFns } from "./ViewTask.vue?vue&type=template&id=20115ffe&scoped=true&"
import script from "./ViewTask.vue?vue&type=script&lang=js&"
export * from "./ViewTask.vue?vue&type=script&lang=js&"
import style0 from "./ViewTask.vue?vue&type=style&index=0&id=20115ffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20115ffe",
  null
  
)

export default component.exports